<div class="container-fluid">
    <div class="row">
        <div
            class="col-12 col-sm-5 d-none d-sm-flex flex-column min-full-height justify-content-between left-panel position-relative">
            <img src="../../../assets/images/Logo-colorido.png" alt="Logo" class="logo" />
            <p class="bottom-text">
                Avoid The Headache, Get a Simple Solution That Meets Your Needs
            </p>
        </div>
        <div class="col-12 d-sm-none pt-5 px-4">
            <img src="../../../assets/images/Logo-colorido.png" alt="Logo" class="logo" />
        </div>
        <div class="col-12 col-sm-7 d-flex align-items-center justify-content-center">





            <div class="container" style="width: 450px; height: 260px;">


                <h4 class="title mb-3">Verify Your Identity</h4>

                <div class="card-body">
                    <h5 class="card-title mb-2"><strong>verification method</strong> </h5>
                    <p class="card-text text-muted">We'll send a 6-digit code to verify your identity.</p>


                    <!-- Method Selection -->
                    <div class="mb-4">
                        <div class="row g-3">

                            <div class="col-md-6">
                                <div class="method-option {{ isEmailSelected }}" id="emailOption" (click)="selectMethod('email')">
                                    <input type="radio" name="verificationMethod" id="email"
                                        value="email" required [checked]="selectedMethod === 'email'">
                                    <label class="form-check-label fw-bold" style="margin-left: 10px;"
                                        for="email">Email</label>
                                    <div [appTooltip]="maskEmail()" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="contact-preview" id="emailPreview">{{ maskEmail()}}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="method-option {{ isSmsSelected }}" id="smsOption" (click)="selectMethod('sms')">
                                    <input type="radio" name="verificationMethod" id="sms"
                                        value="sms" required [checked]="selectedMethod === 'sms'">
                                    <label class="form-check-label fw-bold" style="margin-left: 10px;"
                                        for="sms">SMS</label>
                                    <div  [appTooltip]="maskPhoneNumber()" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="contact-preview" id="smsPreview">{{ maskPhoneNumber() }}</div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <button class="btn btn-primary w-100 py-2 mb-3" (click)="sendVerificationCode()">Send Verification Code</button>
                    <button class="btn btn-primary w-100 py-2" (click)="goBack()">Cancel</button>

                </div>
            </div>
        </div>





    </div>

</div>